<script>
  import NewsletterMail from './pages/NewsletterMail.svelte';
  import NewsletterSidebar from './pages/NewsletterSidebar.svelte';
  import NewsletterModal from './pages/NewsletterModal.svelte';
  import NewsletterModalMobile from './pages/NewsletterModalMobile.svelte';

  export let isMobile;
  export let startTimeout;
</script>

<div class="nl-container">
  {#if !isMobile}
    <NewsletterSidebar />
    <NewsletterMail />
    <NewsletterModal {startTimeout} />
  {:else}
    <NewsletterModalMobile />
  {/if}
</div>

<style lang="scss">
  @import '../styles/mixins';

  .nl-container {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
  }
</style>
